import {HTTP, HTTPAUTH} from '../../utils/http-base';
import store from 'store';
import router from '@/router';






// initial state
const state = {
  user : null,
  isLoggedIn : false,
}

// getters
const getters = {
  isLoggedIn : function(state){
    return state.isLoggedIn;
  },
  getUserInfo : (state) => {
    return state.user
  }
}

// actions
const actions = {
  userLogin : function({commit, dispatch}, payload){
    return new Promise(function(resolve, reject){
      dispatch('setIsWaiting', {isWaiting : false, message : ''});
      HTTP.post('/api/users/signin', payload)
      .then((response) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''});
          let data = response.data
          if(data.confirmation !== 'success'){
            reject(data);
          } else {
              HTTPAUTH.defaults.headers['Authorization'] = data.token;
              commit('setUserToken', data.token);
              commit('setUserDetails', data.user)
              dispatch('loadSurveys');
              if(router.currentRoute.query.redirect){
                router.push({ path: router.currentRoute.query.redirect })
              } else {
                router.push({ path: '/create/quote-summary' });
              }
              resolve(data);
          }
      })
      .catch((err) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''});
        reject(err);
      })
    })
  },

  userRegister : ({commit, dispatch}, formData) => {
    return new Promise(function(resolve, reject){
      dispatch('setIsWaiting', {isWaiting : false, message : ''});
      console.log('login iswaiting');
      HTTP.post('/api/users/signup', formData)
      .then((response) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''});
          let data = response.data
          if(data.confirmation !== 'success'){
              resolve(data);
          } else {
              commit('setUserToken', data.token);
              commit('setUserDetails', data.user)
              HTTPAUTH.defaults.headers['Authorization'] = data.token;
              if(router.currentRoute.query.redirect){
        
                router.push({ path: router.currentRoute.query.redirect })
              } else {
                router.push({ path: '/create/quote-summary' })
              }
              resolve(data);
          }

      })
      .catch((err) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''});
        reject(err);
      })
    })
  },

  checkLoggedIn : ({commit, state, dispatch}) => {
      dispatch('setIsWaiting', {isWaiting : true, message : 'Please wait'});
      // GET USER DETAILS USING HTTPAUTH
      HTTPAUTH.post('/api/user/checkLoggedIn')
      .then((response) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''});

         if(response.data.confirmation !== 'success'){
            commit('logout');
            
            return
         }
         if(response.data.confirmation === 'success'){
              
            commit('setUserDetails', response.data.data);
            dispatch('loadSurveys');
            if(router.currentRoute.query.redirect){
        
                router.push({ path: router.currentRoute.query.redirect })
              } 
         }
      })
      .catch((err) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''});
         commit('logout');
      })

    
  },

  // handles the creation of a token
  userResetPassword : ({commit, dispatch}, email) => {
    return new Promise(function(resolve, reject){
      dispatch('setIsWaiting', {isWaiting : true, message : 'Please wait...'})
        HTTP.post('/api/user/forgotpassword', email)
        .then((response) => {
          dispatch('setIsWaiting', {isWaiting : false, message : ''});
            let data = response.data
            if(data.confirmation === 'fail'){
                reject(data);
            } else {
                router.push({ path: '/user/forgotpassword' })
                resolve(data);
            }

        })
        .catch((err) => {
          dispatch('setIsWaiting', {isWaiting : false, message : ''});
          reject(err);
        })
    });
  },
  // sets a new password for the user if they provide the correct token
  userResetPasswordConfirm : ({commit, dispatch}, formData) => {
    return new Promise(function(resolve, reject){
        let resetToken = formData.resetToken;
        delete formData.resetToken;
        dispatch('setIsWaiting', {isWaiting : true, message : 'Please wait...'})
        HTTP.post('/api/user/forgotpassword/' + resetToken, formData)
        .then((response) => {
          dispatch('setIsWaiting', {isWaiting : false, message : ''});
          console.log(response);
            let data = response.data
            if(data.confirmation === 'fail'){
                reject(data);
                return;
            }
            if(data.confirmation === 'validation'){
                reject(data);
                return;
            }
            if(data.confirmation === 'success') {
                router.push({ path: '/login-or-register' })
                resolve(data);
                return;
            }

        })
        .catch((err) => {
          dispatch('setIsWaiting', {isWaiting : false, message : ''});
          reject(err);
        })
    });
  },

  updateUserDetails : ({commit, dispatch}, payload) => {
    return new Promise(function(resolve, reject){
      dispatch('setIsWaiting', {isWaiting : true, message : 'Please wait...'})
      HTTPAUTH.put('/api/user/' + payload.userId , payload.data)
      .then((response) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''});
          let data = response.data
          if(data.confirmation === 'fail' || data.confirmation === 'validation'){
              reject(data);
          } else {
              resolve(data);
              commit('setUserDetails', data.data)
          }

      })
      .catch((err) => {
        dispatch('setIsWaiting', {isWaiting : false, message : ''});
        reject(err);
      })
  });
  },

  userLogout : ({commit}) => {
    commit('logout');
    router.push({ path: '/login-or-register' })
    commit('resetSurveyData');
  }
}

// mutations
const mutations = {

  setUserToken(state, payload){
    store.set('topographicalapp-token', payload);
  },

  setUserDetails(state, payload){
    state.user = payload;
     state.isLoggedIn = true;
     
  },

  logout(state){
    state.user = null,
    state.isLoggedIn = false;
    store.remove('topographicalapp-token');
    delete HTTPAUTH.defaults.headers['Authorization']
  }

}

export default {
  state,
  getters,
  actions,
  mutations,
  
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js